/**
 * Remove caracteres especiais de um documento (CPF ou CNPJ) preservando letras e numeros.
 *
 * Esta funcao e especifica para documentos brasileiros que podem conter caracteres
 * alfanumericos (CNPJs alfanumericos introduzidos em julho de 2026).
 *
 * @param rawDocument - Documento com ou sem mascara (ex: "12.ABC.345/01DE-35" ou "12ABC34501DE35")
 * @returns Documento limpo contendo apenas letras e numeros em uppercase
 *
 * @example
 * cleanDocument("12.ABC.345/01DE-35") // "12ABC34501DE35"
 * cleanDocument("123.456.789-01") // "12345678901"
 * cleanDocument("12.345.678/0001-95") // "12345678000195"
 */
export const cleanDocument = (rawDocument: string): string => {
  return rawDocument.replace(/[^A-Za-z0-9]/g, '').toUpperCase() || ''
}
